import moment from 'moment'
import React from 'react'
import { DateRange, DayPicker } from 'react-day-picker'
import { fi } from 'react-day-picker/locale'
import { i18n } from '../../domain/index'
import css from './weekField.css'

// eslint-disable-next-line import/no-unresolved
import '!style-loader!css-loader!react-day-picker/style.css'

type Props = {
  value: string
  label?: string
  onChange?: (...props: any) => any
}

type State = {
  week: string
  open: boolean
}

const modifiersStyles = {
  selected: {
    backgroundColor: 'rgb(120, 162, 47, 0.5)',
  },
}

class WeekField extends React.Component<Props, State> {
  node: any

  constructor(props: Props) {
    super(props)

    this.state = {
      week: props.value || moment().format('GGGG[W]WW'),
      open: false,
    }
  }

  UNSAFE_componentWillMount() {
    //TODO: rewrite outdated and unsafe life circle hooks
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // Update state week if value changes in props.
    if (nextProps.value !== this.state.week) {
      this.setState({ week: nextProps.value })
    }
  }

  handleClick = (e: any) => {
    if (this.node.contains(e.target)) {
      return
    }

    this.setState({
      open: false,
    })
  }

  getFieldValue = () => {
    const from = moment(this.state.week).startOf('week')
    const to = moment(this.state.week).endOf('week')
    return `${from.format('w')} (${from.format('D.M.')} - ${to.format('D.M.YYYY')})`
  }

  getSelectedRange = () => {
    const from = moment(this.state.week).startOf('week')
    const to = moment(this.state.week).endOf('week')

    return {
      from: from.toDate(),
      to: to.toDate(),
    }
  }

  onWeekClick = (range?: DateRange) => {
    this.changeWeek(moment(range?.from).format('GGGG[W]WW'))
  }

  onDayClick = (date: Date) => {
    this.changeWeek(moment(date).format('GGGG[W]WW'))
  }

  onFieldClick = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  changeWeek = (week: string) => {
    this.setState({
      week: week,
      open: false,
    })

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(week)
    }
  }

  render() {
    const { label } = this.props
    const isLabelShown = !!label || typeof label === 'undefined'

    const modifiers = {
      selectedRange: this.getSelectedRange(),
    }

    return (
      <div className={css.component} ref={(node) => (this.node = node)}>
        <div className={css.field} onClick={this.onFieldClick}>
          {isLabelShown && <div className={css.label}>{label || i18n.t('weekField.defaultLabel')}:</div>}
          <div className={css.input}>{this.getFieldValue()}</div>
        </div>
        <div className={css.pickerContainer}>
          <div className={css.picker}>
            {this.state.open && (
              <DayPicker
                showWeekNumber
                showOutsideDays
                required={false}
                mode='range'
                weekStartsOn={1}
                onSelect={this.onWeekClick}
                selected={modifiers.selectedRange}
                modifiersStyles={modifiersStyles}
                locale={fi}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default WeekField
